module.exports = __webpack_public_path__ + "media/images/sports_icons/pool-6ec25f83d404285c462b49a130f3b5a7.png";